/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 50dd1bb1cbdc
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";
import {
  AssetDeliveryType,
  AssetDeliveryType$zodSchema,
} from "./assetdeliverytype.js";
import {
  FetchDeliveryType,
  FetchDeliveryType$zodSchema,
} from "./fetchdeliverytype.js";
import {
  GeneratedDeliveryType,
  GeneratedDeliveryType$zodSchema,
} from "./generateddeliverytype.js";
import {
  ManagedDeliveryType,
  ManagedDeliveryType$zodSchema,
} from "./manageddeliverytype.js";
import {
  SocialDeliveryType,
  SocialDeliveryType$zodSchema,
} from "./socialdeliverytype.js";

export const DeliveryTypeAllEnum = {
  MediaOptimization: "media_optimization",
} as const;
export type DeliveryTypeAllEnum = ClosedEnum<typeof DeliveryTypeAllEnum>;

export const DeliveryTypeAllEnum$zodSchema = z.enum([
  "media_optimization",
]);

/**
 * All supported delivery types.
 */
export type DeliveryTypeAll =
  | ManagedDeliveryType
  | AssetDeliveryType
  | FetchDeliveryType
  | SocialDeliveryType
  | GeneratedDeliveryType
  | DeliveryTypeAllEnum;

export const DeliveryTypeAll$zodSchema: z.ZodType<DeliveryTypeAll> = z.union([
  ManagedDeliveryType$zodSchema,
  AssetDeliveryType$zodSchema,
  FetchDeliveryType$zodSchema,
  SocialDeliveryType$zodSchema,
  GeneratedDeliveryType$zodSchema,
  DeliveryTypeAllEnum$zodSchema,
]).describe("All supported delivery types.");
